module.exports = __webpack_public_path__ + "img/empty-identity.00cbbc3c.svg";